<template>
<div>
  <b-card>
    <div class="text-right mb-3">
      <router-link class="btn btn-primary" :to="{name:'bestof_objectives.create'}"><i class="fa fa-plus"></i> Criar</router-link>
    </div>
    <grid-filters grid-data="theGrid" :fields="gridFilters" ></grid-filters>
    <Grid ref="theGrid" name="bestofObjectives" v-bind:url="url" v-bind:preload="preload" v-bind:columns="columns" :pageable='true' :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields"></Grid>
  </b-card>
</div>
</template>

<script>
import Grid from '@/components/Grid.vue'
import router from '@/router'
import lists from '@/components/States.js'

export default {
  name: 'bestofObjectives',
  components: {
    Grid
  },
  data() {
    return {
      gridFilters: [{
        field:'campaign_id',
        modal:'bestof-modal',
        foreign: 'id',
        placeholder: 'Campanha'
      }, {
        field:'dealer_id',
        modal:'dealers-modal',
        foreign: 'id',
        placeholder: 'Distribuidor'
      }, {
        field:'zone',
        modal:'zones-modal',
        foreign: 'zone',
        placeholder: 'Zona'
      }],
      schemaModelFields: {
        'created_at': {
          type: 'date'
        },
        'dealer_id': {
          type: 'number'
        }
      },
      preload: [{
        api: 'dealers/lst',
        field: 'dealer_id'
      }, {
        api: 'bestof/campaigns/lst',
        field: 'campaign_id'
      }],
      url: 'bestof/objectives',
      columns: [{
        template: this.getBtnTemplate,
        title: '',
        width: '120px'
      },
      {
        field: 'campaign_id',
        title: 'Campanha',
        width: '220px'
      },
      {
        field: 'dealer_id',
        title: 'Distribuidor',
        width: '220px'
      },
      {
        field: 'zone',
        title: 'Zona',
        width: '120px'
      },
      {
        field: 'value',
        title: 'Valor',
        width: '120px'
      },
      {
        field: 'operators',
        title: 'Operadores',
        width: '120px'
      },
      {
        field: 'quantity',
        title: 'Quantidade',
        width: '120px'
      },
      {
        field: 'created_at',
        title: 'Criado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          // ui: "datetimepicker"
          ui: function(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            })
          }
        }
      }]
    }
  },
  methods: {
    getBtnTemplate: function(item) {
      var route = router.resolve({
        name: 'bestof_objectives.edit',
        params: {
          id: item.id
        }
      })
      if (this.$auth.check('bestof_objectives.edit')) {
        return '<a href="' + route.href + '" class="btn btn-primary" ><i class="fa fa-pencil"></i> editar</a>'
      }
      return ''
    }
  }
}
</script>
